import React from 'react';
import { Display, Heading, Label, Body } from '../components/Typography';
import Button from '../components/Button';

const ProgrammeLeadership = () => {
  return (
    <article className="w-full bg-epoq-paper">
      {/* Header */}
      <header className="pt-20 pb-32 px-6 lg:px-12 border-b border-epoq-blue/20">
        <div className="max-w-5xl mx-auto">
          <Label className="text-epoq-coral mb-8 block">Programme 01</Label>
          <Display className="mb-12">AI for Leadership <br/>and Boards</Display>
          
          <div className="grid md:grid-cols-2 gap-12 mt-16">
            <div className="text-xl font-serif leading-relaxed italic text-epoq-blue/80">
              Artificial intelligence is no longer only a technology decision. It is a question of business direction, organisational responsibility, investment and governance.
            </div>
            <div className="space-y-6">
              <Body>
                This programme helps leaders and board members move beyond general awareness.
              </Body>
              <Body>
                Participants learn how to evaluate opportunities, ask better questions, prioritise use cases, understand major risks and define realistic next steps.
              </Body>
            </div>
          </div>
        </div>
      </header>

      {/* Details Grid */}
      <section className="py-24 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-16">
          
          {/* Left Column (Metadata) */}
          <div className="lg:col-span-4 space-y-16">
            <div>
              <Label className="mb-6 block border-b border-epoq-blue/10 pb-2">Target Participants</Label>
              <ul className="space-y-3 font-sans opacity-90">
                {['Board members', 'CEOs', 'COOs', 'CFOs', 'CIOs and digital leaders', 'Business directors', 'Senior HR leaders', 'Compliance leaders', 'Transformation leaders'].map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <span className="text-epoq-coral mt-1 text-xs">■</span> {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <Label className="mb-6 block border-b border-epoq-blue/10 pb-2">Format</Label>
              <p className="opacity-90 mb-4">One day in person or two half-days live online.</p>
              <p className="opacity-70 text-sm italic">Suitable for open cohorts and closed leadership or board programmes.</p>
            </div>

            <div className="bg-epoq-blue text-epoq-white p-8">
              <h4 className="font-serif text-2xl mb-6">Take the next step</h4>
              <Button to="/contact" variant="secondary" className="w-full mb-4">Register your interest</Button>
              <Button to="/contact" variant="outline" className="w-full border-epoq-white text-epoq-white hover:bg-epoq-white hover:text-epoq-blue">Discuss a closed programme</Button>
            </div>
          </div>

          {/* Right Column (Content) */}
          <div className="lg:col-span-7 lg:col-start-6 space-y-24">
            
            <div>
              <Heading className="mb-10 text-4xl">Learning Outcomes</Heading>
              <p className="mb-6 opacity-60 italic font-serif">Participants should leave able to:</p>
              <ul className="space-y-6 text-lg border-l-2 border-epoq-lime pl-6">
                <li>Distinguish strategic opportunity from technology hype</li>
                <li>Identify and prioritise relevant AI use cases</li>
                <li>Assess value, readiness and risk</li>
                <li>Understand key governance, privacy and responsibility questions</li>
                <li>Clarify leadership and organisational ownership</li>
                <li>Define a practical 90-day direction</li>
              </ul>
            </div>

            <div>
              <Heading className="mb-10 text-4xl">Programme Structure</Heading>
              <div className="space-y-8">
                {[
                  'The current business reality of AI',
                  'Opportunities, use cases and investment priorities',
                  'Risk, governance and responsible decision-making',
                  'Organisational readiness and responsibility',
                  'The 90-day leadership plan'
                ].map((item, i) => (
                  <div key={i} className="flex gap-6 items-baseline border-b border-epoq-blue/10 pb-6">
                    <span className="font-serif text-3xl text-epoq-blue/30 w-8">{i+1}</span>
                    <span className="text-xl font-medium">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <Heading className="mb-10 text-4xl">Practical Work</Heading>
              <div className="grid grid-cols-2 gap-x-8 gap-y-4 font-sans opacity-80">
                <div className="bg-white p-4 border border-epoq-blue/10">Use-case prioritisation</div>
                <div className="bg-white p-4 border border-epoq-blue/10">Leadership decision scenarios</div>
                <div className="bg-white p-4 border border-epoq-blue/10">Risk and responsibility mapping</div>
                <div className="bg-white p-4 border border-epoq-blue/10">A short strategic direction document</div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </article>
  );
};

export default ProgrammeLeadership;